var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"pot-checker-item",class:{'pot-checker-item_active': _vm.isActive},on:{"click":_vm.clickHandler}},[_vm._t("default",[_c('span',{domProps:{"innerHTML":_vm._s(_vm.option.text)}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }